import { render, staticRenderFns } from "./waterset.vue?vue&type=template&id=580402bf&scoped=true&"
import script from "./waterset.vue?vue&type=script&lang=js&"
export * from "./waterset.vue?vue&type=script&lang=js&"
import style0 from "@/assets/usercenter.less?vue&type=style&index=0&id=580402bf&lang=less&scoped=true&"
import style1 from "./waterset.vue?vue&type=style&index=1&id=580402bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580402bf",
  null
  
)

export default component.exports